// extracted by mini-css-extract-plugin
module.exports =  {"like-button":"_32bbee5fda--like-button--oHSQJ","button-text":"_32bbee5fda--button-text--tT1ME"};